import { APIResponse } from 'types/Request';
import { getCookie } from 'helpers';
import config from 'config';

export async function getSeguroPraxisMedica(matricula: number): Promise<string|false> {
  try {
    const url = new URL(`${ config.baseUrl }/matriculates/${ matricula }/certificate/v2`);

    type Response = APIResponse<string|false>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      console.error(response.statusText);
      throw new Error('Ocurrió un error al recuperar el certificado de praxis médica.');
    }

    const content = await response.json() as Response;

    if (content.status === 'error' && content.code === 'MATRICULATE_INACTIVE') {
      throw new Error('Su usuario no se encuentra activo para realizar esta operación.');
    }

    if (content.error) {
      console.error(content.error);
      throw new Error('Ocurrió un error al recuperar el certificado de praxis médica.');
    }

    return content.payload!;
  } catch (err) {
    throw new Error(
      err ??
      'Ocurrió un problema inesperado al momento de recuperar el certificado de praxis médica.',
    );
  }
}
